module.exports = __webpack_public_path__ + "static/img/313.8a5933fa.jpg";